module.exports = __webpack_public_path__ + "static/contact_writing-0643f849e1c7380cd306b426e4e54141.svg";